import React, { useEffect, useRef, useState } from 'react';
import { Formik, Form as FormikForm, Field, ErrorMessage } from 'formik';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as Yup from 'yup';
import { Row, Col, Button, Card } from 'react-bootstrap';
import PageTitle from '../../../layouts/PageTitle';
import { connect, useDispatch, useSelector } from 'react-redux';
import { employeeSearchList } from '../../../../store/selectors/BoxSelectors';
import { getProfile } from '../../../../store/selectors/AuthSelectors';
import moment from 'moment';
import AsyncSelect from 'react-select/async';
import 'react-datepicker/dist/react-datepicker.css';
import { useLoader } from '../../../../context/LoaderCotext';
import Swal from 'sweetalert2';
import Select from 'react-select';
import { retrieveData, storeData } from '../../../../services/indexedDBUtils';
import {
  getBoxAuthToken,
  getBoxAuthUrl,
  getUsersSearch,
  uploadFileBatch,
} from '../../../../services/BoxService';
import { useAuth } from '../../../../context/authContext';
import Cookies from 'js-cookie';
import { createFormAction } from '../../../../store/actions/FormsActions';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { employeeSearchAction } from '../../../../store/actions/BoxActions';
import { getBoxFolderOfEmpByEmail } from '../../../../services/BoxFolderOfEmpService';
import { getJobTitles } from '../../../../services/JobtitleService';
import { getJobTypes } from '../../../../services/JobtypeService';

const validationSchema = Yup.object({
  initiator: Yup.string().required('Initiator name required'),
  manager: Yup.string().required('Manager name required'),
  ssaiTitle: Yup.string().required('SSAI Title is required'),
  payRange: Yup.string()
    .required('Pay range is required')
    .matches(/^[\d\s\-]+$/, 'Only numbers, spaces, and dashes are allowed'),
  status: Yup.string().required('Status is required'),
  hiringManager: Yup.string().required('Hiring Manager is required'),
  employeeReplacement: Yup.boolean().required('Required'),
  employeeReplacementName: Yup.string().test(
    'employeeReplacementName',
    'This field is required because employee replacement is YES',
    function (value) {
      const { employeeReplacement } = this.parent;
      if (employeeReplacement === true || employeeReplacement === 'true') {
        return value !== undefined && value.trim() !== '';
      }
      return true;
    }
  ),
  contract: Yup.string().required('Contract is required'),
  location: Yup.string().required('Location is required'),
  websiteTitle: Yup.string().required('Website title is required'),
  jobDescription: Yup.string().required('Job description is required'),
  requiredQualification: Yup.string().required('Required Qualification is required'),
  desiredQualifications: Yup.string().required('Desired Qualification is required'),
  citizenshipRequired: Yup.string().required('Citizenship requirement is required'),
  requisitionAccess: Yup.string(),
});

const RequisitionForm = ({ profile }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const { showLoader, hideLoader } = useLoader();
  const [selectLocation, setSelectLocation] = useState('');
  const [submitterName, setSubmitterName] = useState(''); // Add this line
  const employeeList = useSelector(employeeSearchList);
  const locationRef = useRef(null);
  const formikRef = useRef(null);
  const [hasDashboardMenu, setHasDashboardMenu] = useState(true);
  const [statusList, setStatusList] = useState([]);
  const [jobTitleList, setJobTitleList] = useState([]);
  const [contractList, setContractList] = useState([
    {
      label: 'SAMDA',
      value: 'SAMDA',
    },
    {
      label: 'Corporate',
      value: 'Corporate',
    },
    {
      label: 'HBG',
      value: 'HBG',
    },
    {
      label: 'ESES',
      value: 'ESES',
    },
  ]);
  const [citizenshipRequiredList, setcitizenshipRequiredList] = useState([
    {
      label: 'US Citizen',
      value: 'US Citizen',
    },
    {
      label: 'Permanent Residence',
      value: 'Permanent Residence',
    },
    {
      label: 'Both',
      value: 'Both',
    },
    {
      label: 'Not Required',
      value: 'Not Required',
    },
  ]);
  const [folderAPISuccess, setFolderAPISuccess] = useState(false);
  const [cookieValue, setCookieValue] = useState(Cookies.get('boxToken'));
  const [initialValues, setInitialValues] = useState({
    initiator: '',
    manager: '',
    ssaiTitle: '',
    payRange: '',
    status: '',
    hiringManager: '',
    employeeReplacement: 'false',
    employeeReplacementName: '',
    contract: '',
    location: '',
    websiteTitle: '',
    jobDescription: '',
    requiredQualification: '',
    desiredQualifications: '',
    citizenshipRequired: '',
    requisitionAccess: '',
    boxFolderId: '275393000439',
    boxFolderName: 'requisition-forms',
    timestamp: moment().unix(),
  });

  useEffect(() => {
    dispatch(employeeSearchAction(''));
    if (typeof profile != 'undefined') {
      setSubmitterName(profile.firstName + ' ' + profile.lastName);
      setInitialValues((prev) => ({
        ...prev,
        initiator: profile.firstName + ' ' + profile.lastName,
      }));
    }
    if (profile && profile.allowedModules) {
      const hasDashboard = profile.allowedModules.some(
        (module) => module.value.trim() === 'dashboard' && module.operations.includes('menu')
      );
      if (hasDashboard == false) {
        setHasDashboardMenu(false);
      }
    }
  }, [profile]);

  useEffect(() => {
    const searchParams = new URLSearchParams(selectLocation.search);
    const authCode = searchParams.get('code');
    const apiCall = async () => {
      if (typeof authCode != 'undefined' && authCode != '' && authCode != null) {
        await getBoxAuthToken(authCode)
          .then(async (response) => {
            if (typeof response.data.key != 'undefined') {
              const expiryDate = new Date();
              expiryDate.setTime(expiryDate.getTime() + response.data.life * 1000);
              Cookies.set('boxToken', response.data.key, {
                expires: expiryDate,
                path: '/',
                secure: true,
              });
              setCookieValue(Cookies.get('boxToken'));
              setFolderAPISuccess(true);
            }
          })
          .catch(async (error) => {});
      } else {
        setFolderAPISuccess(true);
      }
    };
    if (typeof cookieValue == 'undefined' && hasPermission('box-folders', ['show']) == true) {
      apiCall();
    } else {
      setFolderAPISuccess(true);
    }
  }, [cookieValue]);

  const loadOptions = (inputValue, callback) => {
    if (!inputValue) {
      callback([]);
      return;
    }
    getUsersSearch(inputValue)
      .then((response) => {
        const options = response.data.map((employee) => ({
          value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          email: employee.email,
          employeeNumber: employee.employeeNumber,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error('Error fetching employee data', error);
        callback([]);
      });
  };

  const handleUploadBatch = async (data) => {
    const payload = {
      submitterName: profile ? profile.firstName + ' ' + profile.lastName : '',
      submitterEmail: profile.email,
      status: 'in progress',
      formType: 'requisition-forms',
      contractor: 'ssai',
      dynamicFields: [
        {
          submitter: profile ? profile.firstName + ' ' + profile.lastName : '',
          ...data,
        },
      ],
    };
    if (
      localStorage.getItem('formDataJSON') == null ||
      typeof localStorage.getItem('formDataJSON') == 'undefined'
    ) {
      localStorage.setItem('formDataJSON', await storeData(payload));
    }

    const formData = await retrieveData(parseInt(localStorage.getItem('formDataJSON')));

    if (formData) {
      const payload = {
        data: formData.dynamicFields,
        key: cookieValue || '',
        isBoxExplorer: hasPermission('box-folders', ['show']) || false,
      };
      try {
        showLoader();
        const response = await uploadFileBatch(payload);
        if (Array.isArray(formData.dynamicFields)) {
          formData.dynamicFields.forEach((data, index) => {
            if (index === formData.dynamicFields.length - 1) {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, navigate));
            } else {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, undefined));
            }
          });
        } else {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        }

        Swal.fire({
          icon: 'success',
          title: 'Request submitted',
          text: 'Your request is submitted please wait for approver',
          width: 400,
          confirmButtonColor: '#3a7afe',
        }).then(() => {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        });
      } catch (error) {
        if (
          typeof error.response != 'undefined' &&
          typeof error.response.status != 'undefined' &&
          error.response.status == '501'
        ) {
          Swal.fire({
            icon: 'error',
            title: 'Employee Data Error',
            text: 'Employee data not exist on box, Please contact your admin',
            width: 400,
            confirmButtonColor: '#3a7afe',
          });

          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Request not submitted',
            text: 'Please contact your admin',
            width: 400,
            confirmButtonColor: '#3a7afe',
          });
          console.error(
            'Error uploading file:',
            error.response ? error.response.data : error.message
          );
        }
      } finally {
        hideLoader();
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Data not existed',
        text: 'Please contact your admin',
        width: 400,
        confirmButtonColor: '#3a7afe',
      });

      hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
    }
  };

  const handleStatusChange = (selectedOption, setFieldValue) => {
    setFieldValue('status', selectedOption.value);
  };

  const handleContractChange = (selectedOption, setFieldValue) => {
    setFieldValue('contract', selectedOption.value);
  };

  useEffect(() => {
    let autocomplete;
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?libraries=places&language=en&key=AIzaSyA96sWp8b6UT3Fbt65VY-FE3acygsCm8T0&callback=initAutocomplete`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    window.initAutocomplete = () => {
      if (locationRef.current) {
        autocomplete = new window.google.maps.places.Autocomplete(locationRef.current, {
          types: ['(cities)'],
        });

        autocomplete.addListener('place_changed', () => {
          const place = autocomplete.getPlace();
          const fullAddress = place.formatted_address || '';
          setSelectLocation(fullAddress);
          if (locationRef.current) {
            locationRef.current.value = fullAddress;
          }
          if (formikRef.current) {
            formikRef.current.setFieldValue('location', fullAddress);
          }
        });
      }
    };

    return () => {
      if (autocomplete) {
        window.google.maps.event.clearInstanceListeners(autocomplete);
      }
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const getJobTitle = async () => {
      const response = await getJobTitles();
      setJobTitleList(response);
    };
    getJobTitle();
    const getJobType = async () => {
      const response = await getJobTypes();
      setStatusList(response);
    };
    getJobType();
  }, []);

  const handleCitizenChange = (selectedOption, setFieldValue) => {
    setFieldValue('citizenshipRequired', selectedOption.value);
  };

  const handleSubmit = (data) => {
    if (typeof data != 'undefined') {
      const payloadForms = {
        ...data,
        submitter: profile ? profile.firstName + ' ' + profile.lastName : '',
      };
      handleUploadBatch(payloadForms);
    }
  };

  return (
    <>
      <PageTitle pageTitle="Requisition Request Form" />
      <Card>
        <div
          className="d-flex justify-content-end"
          style={{ fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}
        >
          <Link
            className="mb-2 text-primary"
            target="_blank"
            to="https://ssaihq.app.box.com/file/1830540268102"
          >
            Position Matrix File
          </Link>
          <Link className="mb-2 text-primary" target="_blank" style={{ marginLeft: '40px' }} to="#">
            Instruction to Submit Requisition form
          </Link>
        </div>
        <Formik
          innerRef={formikRef}
          validationSchema={validationSchema}
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ values, setFieldValue, isSubmitting }) => (
            <FormikForm>
              <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                <Col>
                  <div className="form-group">
                    <label htmlFor="initiator">Form Initiator Name</label>
                    <Field
                      type="text"
                      name="initiator"
                      className="form-control"
                      placeholder="Form Initiator"
                      value={values.initiator}
                      readOnly
                    />
                    <ErrorMessage name="initiator" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="manager">Manager Name</label>
                    <AsyncSelect
                      name="manager"
                      loadOptions={loadOptions}
                      defaultOptions={employeeList}
                      placeholder="Select Manager"
                      isSearchable
                      onChange={(selectedOption) => {
                        setFieldValue('manager', selectedOption.label);
                      }}
                    />
                    <ErrorMessage name="manager" component="div" className="text-danger" />
                  </div>
                </Col>

                <Col>
                  <div className="form-group">
                    <label htmlFor="ssaiTitle">SSAI Title</label>
                    <Select
                      name={`ssaiTitle`}
                      options={jobTitleList}
                      onChange={(option) => setFieldValue('ssaiTitle', option.value)}
                    />
                    <ErrorMessage name="ssaiTitle" component="div" className="text-danger" />
                  </div>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col>
                  <div className="form-group">
                    <label htmlFor="payRange">Pay Range</label>
                    <div className="input-group">
                      <span className="input-group-text">$</span>
                      <Field
                        type="text"
                        name="payRange"
                        className="form-control"
                        placeholder="Pay Range (e.g., 50000 - 70000)"
                      />
                    </div>
                    <ErrorMessage name="payRange" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="status">Status</label>
                    <Select
                      name={`status`}
                      options={statusList}
                      onChange={(option) => handleStatusChange(option, setFieldValue)}
                    />
                    <ErrorMessage name="status" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="hiringManager">Hiring Manager</label>
                    <AsyncSelect
                      name="hiringManager"
                      loadOptions={loadOptions}
                      defaultOptions={employeeList}
                      placeholder="Select Hiring Manager"
                      isSearchable
                      onChange={(selectedOption) =>
                        setFieldValue('hiringManager', selectedOption.label)
                      }
                    />
                    <ErrorMessage name="hiringManager" component="div" className="text-danger" />
                  </div>
                </Col>
              </Row>
              <Row classname="mb-3">
                <Col>
                  <div className="form-group">
                    <label htmlFor="employeeReplacement">
                      Are you recommending any employee replacement?
                    </label>
                    <ErrorMessage
                      name="employeeReplacement"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                </Col>
                <Col>
                  <div role="group">
                    <label htmlFor="yesemployeeReplacement" style={{ marginRight: '10px' }}>
                      <Field
                        type="radio"
                        name="employeeReplacement"
                        value="true" // keep as string
                        id="yesemployeeReplacement"
                        style={{ marginRight: '5px' }}
                      />
                      Yes
                    </label>

                    <label htmlFor="noemployeeReplacement">
                      <Field
                        type="radio"
                        name="employeeReplacement"
                        value="false" // also string
                        id="noemployeeReplacement"
                        style={{ marginRight: '5px' }}
                      />
                      No
                    </label>
                  </div>
                </Col>
              </Row>
              {JSON.parse(values.employeeReplacement) && (
                <Row className="mb-3">
                  <Col>
                    <div className="form-group">
                      <label htmlFor="employeeReplacementName">Employee Replacement Name</label>
                      <AsyncSelect
                        name="employeeReplacementName"
                        placeholder="Employee Replacement Name"
                        isSearchable
                        loadOptions={loadOptions}
                        defaultOptions={employeeList}
                        onChange={(selectedOption) =>
                          setFieldValue('employeeReplacementName', selectedOption.label)
                        }
                      />
                      <ErrorMessage
                        name="employeeReplacementName"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </Col>
                </Row>
              )}
              <Row className="mb-3">
                <Col>
                  <div className="form-group">
                    <label htmlFor="contract">Contract</label>
                    <Select
                      name={`contract`}
                      options={contractList}
                      onChange={(option) => handleContractChange(option, setFieldValue)}
                    />
                    <ErrorMessage name="contract" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="location">Location</label>

                    <Field name="location">
                      {({ field }) => (
                        <input
                          {...field}
                          ref={locationRef}
                          className="form-control"
                          value={selectLocation}
                          onChange={(e) => {
                            const value = e.target.value;
                            setSelectLocation(value);
                            setFieldValue('location', value);
                          }}
                        />
                      )}
                    </Field>

                    <ErrorMessage name="location" component="div" className="text-danger" />
                  </div>
                </Col>

                <Col>
                  <div className="form-group">
                    <label htmlFor="websiteTitle">Website Title</label>
                    <Field
                      type="text"
                      name="websiteTitle"
                      className="form-control"
                      placeholder="Website Title"
                    />
                    <ErrorMessage name="websiteTitle" component="div" className="text-danger" />
                  </div>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col>
                  <div className="form-group">
                    <label htmlFor="jobDescription">Job Description</label>
                    <Field
                      as="textarea"
                      name="jobDescription"
                      className="form-control"
                      placeholder="Job Description"
                      value={values.jobDescription}
                      rows={8}
                    />
                    <ErrorMessage name="jobDescription" component="div" className="text-danger" />
                  </div>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col>
                  <div className="form-group">
                    <label htmlFor="requiredQualification">Required Qualification</label>
                    <Field
                      as="textarea"
                      name="requiredQualification"
                      className="form-control"
                      placeholder="Required Qualification"
                      value={values.requiredQualification}
                      rows={8}
                    />
                    <ErrorMessage
                      name="requiredQualification"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="desiredQualifications">Desired Qualifications</label>
                    <Field
                      as="textarea"
                      name="desiredQualifications"
                      className="form-control"
                      placeholder="Desired Qualifications"
                      value={values.desiredQualifications}
                      rows={8}
                    />
                    <ErrorMessage
                      name="desiredQualifications"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col>
                  <div className="form-group">
                    <label htmlFor="citizenshipRequired">
                      Does the applicant need to be a US Citizen or Legal Permanent Resident?
                    </label>
                    <Select
                      name={`citizenshipRequired`}
                      options={citizenshipRequiredList}
                      onChange={(option) => handleCitizenChange(option, setFieldValue)}
                    />
                    <ErrorMessage
                      name="citizenshipRequired"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="requisitionAccess">
                      What other SSAI employees need access to this requisition?
                    </label>
                    <Field
                      type="text"
                      name="requisitionAccess"
                      className="form-control"
                      placeholder="Requisition Access"
                    />
                  </div>
                </Col>
              </Row>
              <div className="d-flex justify-content-end">
                <Button variant="primary" type="submit">
                  Submit
                </Button>
              </div>
            </FormikForm>
          )}
        </Formik>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  profile: getProfile(state),
  employeeList: employeeSearchList(state),
});

export default connect(mapStateToProps)(RequisitionForm);
